module.exports = __webpack_public_path__ + "media/assets/icons/hosyo-icon-b15c82aea869bd18af700819645c31dd.svg";